export const getOrdinalSuffix = (num: number): string => {
  const pluralRule = new Intl.PluralRules('en-GB', { type: 'ordinal' });
  const suffixes: Record<Intl.LDMLPluralRule, string> = {
    zero: 'th',
    one: 'st',
    two: 'nd',
    few: 'rd',
    many: 'th',
    other: 'th',
  };

  return suffixes[pluralRule.select(num)];
};

export const isNumber = (val: string | number) => Number.isInteger(Number(val));

export const isBetween = (val: number, start: number, end: number) => val >= start && val <= end;
